import { Button } from '@mui/material'
import { memo, useCallback, useState } from 'react'
import Icon from '../../../../../../components/icon'
import CandidateInfoModal from '../../../candidates/CandidateInfoModal'

const ViewProfile = ({ contestId, candidateId }) => {
  // State
  const [openCandidateInfoModal, setOpenCandidateInfoModal] = useState(false)

  // Handlers
  const handleOpenCandidateInfoModal = useCallback(() => {
    setOpenCandidateInfoModal(true)
  }, [])
  const handleCloseCandidateInfoModal = useCallback(() => {
    setOpenCandidateInfoModal(false)
  }, [])

  return (
    <>
      <Button
        variant="contained"
        className="editor-btn"
        onClick={handleOpenCandidateInfoModal}
        startIcon={<Icon icon="gg:profile" style={{ fontSize: '14px' }} />}
        sx={{ padding: '5px 10px', fontSize: '12px' }}
      >
        Profile
      </Button>
      <CandidateInfoModal
        open={openCandidateInfoModal}
        handleClose={handleCloseCandidateInfoModal}
        candidateId={candidateId}
        contestId={contestId}
      />
    </>
  )
}

export default memo(ViewProfile)
